import { formatObjectToQueries } from '~/shared/utils/formatObjectToQueries';

import { IRetentionsFilters } from '~/modules/retentions/interfaces/IRetentionsFilters';
import { IResalesFilters } from '~/modules/resales/interfaces/IResalesFilters';
import { ILeadsFilters } from '~/modules/leads/interfaces/ILeadsFilters';

export const routes = {
  AUTH: {
    SIGN_IN: '/',
    FORGOT_PASSWORD: '/forgot-password',
    SETUP: '/setup',
    PASSWORD_RECOVERY: '/password-recovery',
  },

  DASHBOARD: '/dashboard',
  LEADS: {
    LIST: (
      filters = {} as Partial<Pick<ILeadsFilters, 'pendings' | 'archived'>>
    ): string => `/leads${formatObjectToQueries(filters)}`,
    CREATE: '/leads/create',
    UPDATE: (leadId: string): string => `/leads/${leadId}`,
  },
  SUBSCRIBERS: {
    LIST: (): string => `/subscribers`,
    CREATE: '/subscribers/create',
    SHOW_DETAILS: (subscriberId: string): string =>
      `/subscribers/${subscriberId}`,
    SHOW_CONSUMPTION_DETAILS: (subscriberId: string): string =>
      `/subscribers/${subscriberId}/consumption`,
    SHOW_SUBSCRIPTION_DETAILS: (subscriberId: string): string =>
      `/subscribers/${subscriberId}/subscriptions`,
    CREATE_SUBSCRIPTION_SYSTEM_CONTRACT: (subscriberId: string): string =>
      `/subscribers/${subscriberId}/subscriptions/create/system`,
    CREATE_SUBSCRIPTION_SYSTEM_AMENDMENT: (
      subscriberId: string,
      subscriptionId: string
    ): string =>
      `/subscribers/${subscriberId}/subscriptions/${subscriptionId}/amendments/system`,
    CREATE_SUBSCRIPTION_RENTAL_CONTRACT: (subscriberId: string): string =>
      `/subscribers/${subscriberId}/subscriptions/create/rental`,
    CREATE_SUBSCRIPTION_RENTAL_AMENDMENT: (
      subscriberId: string,
      subscriptionId: string
    ): string =>
      `/subscribers/${subscriberId}/subscriptions/${subscriptionId}/amendments/rental`,
  },
  ACTIONS: '/actions',
  OFFER_PURCHASES: {
    LIST: '/offer-purchases',
    UPDATE: (id: string): string => `/offer-purchases/${id}`,
  },
  OFFERS: {
    LIST: '/offers',
    CREATE: '/offers/create',
    UPDATE: (id: string): string => `/offers/${id}`,
  },
  COURSES: '/courses',
  RESALES: {
    LIST: (filters = {} as Partial<Pick<IResalesFilters, 'status'>>): string =>
      `/resales${formatObjectToQueries(filters)}`,
    CREATE: '/resales/create',
    UPDATE: (resaleId: string): string => `/resales/${resaleId}`,
  },
  RETENTIONS: {
    LIST: (
      filters = {} as Partial<Pick<IRetentionsFilters, 'status'>>
    ): string => `/retentions${formatObjectToQueries(filters)}`,
    RECORDS: ({
      documentId,
      subscriberId,
      filters = {},
    }: {
      documentId: string;
      subscriberId: string;
      filters: Partial<IRetentionsFilters>;
    }): string =>
      `/retentions/${documentId}/${subscriberId}${
        Object.keys(filters).length > 0 ? formatObjectToQueries(filters) : ''
      }`,
  },
  USERS: '/users',
  PERMISSIONS_GROUPS: '/permissions-groups',
  HELP: {
    LIST: '/help',
    SHOW_DETAILS: (helpId: string): string => `/help/${helpId}`,
  },
  RESOURCES_GROUPS: {
    LIST: '/resources-groups',
    CREATE: '/resources-groups/create',
    UPDATE: (resourcesGroupId: string): string =>
      `/resources-groups/${resourcesGroupId}`,
  },
  OPERATING_AREAS: '/operating-areas',
  FINANCIAL_TITLES: {
    LIST: '/financial-titles',
    SHOW_DETAILS: (document: string, financialTitleId: string): string =>
      `/financial-titles/${document}/${financialTitleId}`,
  },
  FINANCIAL_PAYOUTS: {
    LIST: '/financial-payouts',
    SHOW_DETAILS: (document: string, year: number, month: number): string => {
      return `/financial-payouts/${document}/${year}/${month}`;
    },
  },
};
